import { useState } from 'react';

interface PolicyCompareProps {
  onClose: () => void;
}

const compareData = [
  {
    region: '香港', flag: '🇭🇰', color: '#7C3AED',
    framework: 'SFC证券监管框架',
    status: '全球最友好',
    statusColor: 'bg-emerald-100 text-emerald-700',
    mainLaw: '《证券及期货条例》(SFO)',
    regulator: 'SFC（证监会）+ HKMA（金管局）',
    tokenType: '证券型代币（STO）',
    investorLimit: '仅限专业投资者（PI ≥800万港元）',
    licenseReq: '1类（经纪）+ 4类（顾问）+ 9类（资管）',
    sandbox: '✅ Project Ensemble 批发CBDC沙盒',
    taxPolicy: '资本利得税豁免',
    crossBorder: '✅ 支持跨境发行',
    timeline: '12-18个月',
    minScale: '≥5000万港元',
    rwaFriendly: 5,
    highlights: ['全球最完善RWA监管框架', '12家持牌VATP', '批发CBDC沙盒运行中', '资本利得税豁免'],
  },
  {
    region: '新加坡', flag: '🇸🇬', color: '#10B981',
    framework: 'MAS资本市场服务框架',
    status: '制度完善',
    statusColor: 'bg-teal-100 text-teal-700',
    mainLaw: '《证券与期货法》(SFA)',
    regulator: 'MAS（金融管理局）',
    tokenType: '数字代币（证券型/支付型/实用型）',
    investorLimit: '合格投资者（AI）或机构投资者',
    licenseReq: 'CMS牌照（资本市场服务）',
    sandbox: '✅ Project Guardian 多期运行',
    taxPolicy: '无资本利得税',
    crossBorder: '✅ 支持跨境发行',
    timeline: '12-24个月',
    minScale: '≥3000万新元',
    rwaFriendly: 4,
    highlights: ['Project Guardian领先试点', 'MAS分类监管体系', '无资本利得税', '亚洲机构级RWA首选'],
  },
  {
    region: '欧盟', flag: '🇪🇺', color: '#3B82F6',
    framework: 'MiCA + MiFID II双轨框架',
    status: 'MiCA全面生效',
    statusColor: 'bg-blue-100 text-blue-700',
    mainLaw: 'MiCA条例 + MiFID II指令',
    regulator: 'ESMA + 各成员国监管机构',
    tokenType: 'ART（资产参考代币）/ EMT / 证券代币',
    investorLimit: '视代币类型，部分可向零售开放',
    licenseReq: 'CASP牌照（加密资产服务提供商）',
    sandbox: '✅ DLT试点机制（14家机构获批）',
    taxPolicy: '各成员国不同（德国持有1年免税）',
    crossBorder: '✅ 欧盟单一市场通行',
    timeline: '18-36个月',
    minScale: '≤2亿欧元（DLT试点上限）',
    rwaFriendly: 3,
    highlights: ['27国统一监管框架', 'DLT试点机制运行', '证券代币MiFID II监管', '最大单一市场'],
  },
  {
    region: '美国', flag: '🇺🇸', color: '#F59E0B',
    framework: 'SEC证券法 + 豪威测试',
    status: '审慎监管',
    statusColor: 'bg-amber-100 text-amber-700',
    mainLaw: '《证券法》(1933) + 《证券交易法》(1934)',
    regulator: 'SEC（证券交易委员会）+ CFTC',
    tokenType: '多数认定为证券（豪威测试）',
    investorLimit: '合格投资者（AI：净资产≥100万美元）',
    licenseReq: 'Reg D 506(c) 豁免 / Reg A+ 豁免',
    sandbox: '❌ 无专项沙盒（部分州有创新计划）',
    taxPolicy: '资本利得税（短期/长期不同税率）',
    crossBorder: '⚠️ 限制向美国人发行（Reg S豁免）',
    timeline: '18-36个月',
    minScale: '无下限（Reg D）/ ≤7500万美元（Reg A+）',
    rwaFriendly: 2,
    highlights: ['Reg D 506(c)最常用路径', 'Reg A+可向散户开放', 'BlackRock BUIDL已落地', 'OCC允许银行托管'],
  },
  {
    region: '中国内地', flag: '🇨🇳', color: '#EF4444',
    framework: '全面禁止框架',
    status: '严格禁止',
    statusColor: 'bg-red-100 text-red-700',
    mainLaw: '十部委联合通知（2021.09）',
    regulator: '中国人民银行 + 证监会 + 银保监会等',
    tokenType: '全面禁止（联盟链技术服务除外）',
    investorLimit: '❌ 禁止任何形式代币发行',
    licenseReq: '❌ 无合规路径（境内）',
    sandbox: '❌ 无虚拟货币相关沙盒',
    taxPolicy: '不适用（境内禁止）',
    crossBorder: '⚠️ 唯一路径：境内确权→香港SPV→SFC持牌发行',
    timeline: '24个月以上（通过香港路径）',
    minScale: '≥5000万港元（通过香港路径）',
    rwaFriendly: 1,
    highlights: ['联盟链技术服务合规', '唯一出境路径：香港SPV', '资金回流须CIPS/QFLP', '跨境试点政策研究中'],
  },
];

const compareFields = [
  { key: 'mainLaw', label: '核心法律依据', icon: 'ri-scales-3-line' },
  { key: 'regulator', label: '监管机构', icon: 'ri-government-line' },
  { key: 'tokenType', label: '代币类型认定', icon: 'ri-coin-line' },
  { key: 'investorLimit', label: '投资者限制', icon: 'ri-user-star-line' },
  { key: 'licenseReq', label: '牌照要求', icon: 'ri-award-line' },
  { key: 'sandbox', label: '沙盒/试点', icon: 'ri-test-tube-line' },
  { key: 'taxPolicy', label: '税收政策', icon: 'ri-money-dollar-circle-line' },
  { key: 'crossBorder', label: '跨境发行', icon: 'ri-global-line' },
  { key: 'timeline', label: '预计周期', icon: 'ri-time-line' },
  { key: 'minScale', label: '规模要求', icon: 'ri-bar-chart-line' },
];

export default function PolicyCompare({ onClose }: PolicyCompareProps) {
  const [selectedRegions, setSelectedRegions] = useState<string[]>(['香港', '新加坡', '欧盟']);

  const toggleRegion = (region: string) => {
    setSelectedRegions((prev) => {
      if (prev.includes(region)) {
        if (prev.length <= 2) return prev;
        return prev.filter((r) => r !== region);
      }
      if (prev.length >= 4) return prev;
      return [...prev, region];
    });
  };

  const selectedData = compareData.filter((d) => selectedRegions.includes(d.region));

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center bg-black/50 backdrop-blur-sm overflow-y-auto py-6 px-4">
      <div className="bg-white rounded-2xl w-full max-w-[1200px] overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 bg-gradient-to-r from-[#2E1065] to-[#4C1D95]">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 flex items-center justify-center bg-white/15 rounded-xl">
              <i className="ri-scales-3-line text-white text-lg"></i>
            </div>
            <div>
              <h3 className="text-white font-black text-lg">全球RWA监管框架横向对比</h3>
              <p className="text-white/60 text-xs">选择2-4个地区进行对比 · 数据更新：2026.03</p>
            </div>
          </div>
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-full bg-white/15 hover:bg-white/25 transition-colors cursor-pointer">
            <i className="ri-close-line text-white text-lg"></i>
          </button>
        </div>

        {/* Region Selector */}
        <div className="px-6 py-4 bg-[#F5F3FF] border-b border-[#7C3AED]/10">
          <div className="flex items-center gap-2 flex-wrap">
            <span className="text-xs text-gray-500 font-medium mr-1">选择对比地区（2-4个）：</span>
            {compareData.map((d) => (
              <button
                key={d.region}
                onClick={() => toggleRegion(d.region)}
                className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-semibold transition-all cursor-pointer whitespace-nowrap ${
                  selectedRegions.includes(d.region)
                    ? 'text-white shadow-sm'
                    : 'bg-white border border-gray-200 text-gray-500 hover:border-gray-300'
                }`}
                style={selectedRegions.includes(d.region) ? { backgroundColor: d.color } : {}}
              >
                <span>{d.flag}</span>
                <span>{d.region}</span>
                {selectedRegions.includes(d.region) && <i className="ri-check-line text-xs"></i>}
              </button>
            ))}
            <span className="text-xs text-gray-400 ml-2">已选 {selectedRegions.length}/4</span>
          </div>
        </div>

        {/* Friendly Score Row */}
        <div className="px-6 py-4 border-b border-gray-100">
          <div className="grid gap-3" style={{ gridTemplateColumns: `180px repeat(${selectedData.length}, 1fr)` }}>
            <div className="flex items-center">
              <span className="text-xs font-bold text-gray-500 uppercase tracking-wider">RWA友好度</span>
            </div>
            {selectedData.map((d) => (
              <div key={d.region} className="text-center">
                <div className="flex items-center justify-center gap-2 mb-1">
                  <span className="text-2xl">{d.flag}</span>
                  <div>
                    <div className="font-black text-gray-800 text-sm">{d.region}</div>
                    <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${d.statusColor}`}>{d.status}</span>
                  </div>
                </div>
                <div className="flex items-center justify-center gap-0.5 mt-2">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <i
                      key={star}
                      className={`ri-star-fill text-sm ${star <= d.rwaFriendly ? '' : 'opacity-20'}`}
                      style={{ color: star <= d.rwaFriendly ? d.color : '#9CA3AF' }}
                    ></i>
                  ))}
                  <span className="text-xs text-gray-500 ml-1">{d.rwaFriendly}/5</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Compare Table */}
        <div className="overflow-x-auto">
          <div className="min-w-[700px]">
            {compareFields.map((field, fi) => (
              <div
                key={field.key}
                className={`grid gap-3 px-6 py-4 border-b border-gray-50 ${fi % 2 === 0 ? 'bg-white' : 'bg-[#FAFAFA]'}`}
                style={{ gridTemplateColumns: `180px repeat(${selectedData.length}, 1fr)` }}
              >
                {/* Field Label */}
                <div className="flex items-center gap-2">
                  <div className="w-6 h-6 flex items-center justify-center bg-[#7C3AED]/10 rounded-md shrink-0">
                    <i className={`${field.icon} text-[#7C3AED] text-xs`}></i>
                  </div>
                  <span className="text-xs font-bold text-gray-600">{field.label}</span>
                </div>
                {/* Values */}
                {selectedData.map((d) => {
                  const val = d[field.key as keyof typeof d] as string;
                  const isPositive = val.startsWith('✅');
                  const isNegative = val.startsWith('❌');
                  const isWarning = val.startsWith('⚠️');
                  return (
                    <div key={d.region} className="flex items-start">
                      <span
                        className={`text-xs leading-relaxed ${
                          isPositive ? 'text-emerald-700' : isNegative ? 'text-red-600' : isWarning ? 'text-amber-700' : 'text-gray-700'
                        }`}
                      >
                        {val}
                      </span>
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
        </div>

        {/* Highlights Row */}
        <div className="px-6 py-5 bg-[#F5F3FF] border-t border-[#7C3AED]/10">
          <div className="grid gap-4" style={{ gridTemplateColumns: `180px repeat(${selectedData.length}, 1fr)` }}>
            <div className="flex items-center">
              <span className="text-xs font-bold text-gray-500 uppercase tracking-wider">核心亮点</span>
            </div>
            {selectedData.map((d) => (
              <div key={d.region} className="space-y-1.5">
                {d.highlights.map((h, i) => (
                  <div key={i} className="flex items-start gap-1.5">
                    <div className="w-1.5 h-1.5 rounded-full mt-1.5 shrink-0" style={{ backgroundColor: d.color }}></div>
                    <span className="text-xs text-gray-600 leading-relaxed">{h}</span>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 py-3 border-t border-gray-100 flex items-center justify-between">
          <span className="text-xs text-gray-400">
            <i className="ri-information-line mr-1"></i>
            数据基于各地区官方政策文件整理，仅供参考，不构成法律建议
          </span>
          <button onClick={onClose} className="px-4 py-1.5 bg-[#7C3AED] text-white rounded-full text-xs font-semibold cursor-pointer hover:bg-[#6D28D9] transition-colors whitespace-nowrap">
            关闭对比
          </button>
        </div>
      </div>
    </div>
  );
}
